const Text = ({children, ...props}: any) => {
  return <p {...props}>{children}</p>;
};

export default Text;
